<template>
  <div>
    <div class="w-100 d-inline-block bg-video">
      <div class="container autoContent">
        <div class="row video-section row-scroll">
          <div class="col-xl-4 col-10 col-sm-4 
          col-md-4">
            <div class="video-images float-start margin-top-2 w-xs-40 w-md-auto w-ipad-45">
              <img class="image image-1" src="@/assets/images/amazing-pet-grooming-pet-care-services.png" alt="amazing pet grooming, pet care services" />
              <img class="image image-2" src="@/assets/images/amazing-pet-grooming-pet-care-services-2.png" alt="amazing pet grooming, pet care services" />
              <img class="image image-3" src="@/assets/images/amazing-pet-grooming-pet-care-services-3.png" alt="amazing pet grooming, pet care services" />
            </div>
            <div class="d-inline-block w-60 w-xs-58 w-md-100 w-ipad-55 margin-top-1">
              <p class="mb-0 text-size-11 text-black medium-family text-full-12 customer-text">
                <span class="text-green">500+</span>
                Happy Customers Services 
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 col-sm-4 
          col-md-4">
            <div class="float-start d-inline-block 
            w-28 margin-top-2 work-video-image">
              <a href="javascript:void(0)">
                <img class="w-100" src="@/assets/images/mobile-pet-grooming-mobile-grooming.png" alt="mobile pet grooming, mobile grooming" />
              </a>
            </div>
            <div class="margin-left-2 d-inline-block w-60 w-md-100 w-xs-58">
              <p class="mb-0 text-size-11 text-black customer-text medium-family text-full-12">
                10 Years of Grooming Experience 
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 p-xl-0 col-sm-4 col-md-4">
            <div class="float-start d-inline-block 
            w-28 margin-top-2 work-video-image">
              <a href="javascript:void(0)">
                <img class="w-100" v-lazy="require('@/assets/images/pet-grooming-services-pet-grooming-training.png')" alt="pet grooming services, pet grooming training">
              </a>
            </div>
            <div class="margin-left-2 d-inline-block w-65 w-xs-58 w-md-100">
              <p class="mb-0 text-size-11 text-black customer-text medium-family text-full-12">
                We provide individualised care for every pet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'videoComponent',
};
</script>

<style scoped>
</style>
